import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Typography from '@material-ui/core/Typography'
import { getSourceIcon } from './../../../../libs/DataUtilities'

import last from 'lodash/last'

import numeralHinstance from './../../../../libs/numeral'

import './DataPopoverContent.css'

const sourceIconStyle = {
    height: 14,
    marginLeft: 2,
    marginBottom: -3
}

class DataPopoverContent extends Component {

    /* Methods */

    getSourceCssClass = (source) => {
        return `pages-shared-map-visualizer-data-popover-content__row-${source}`
    }

    /* Handlers */

    /* Lifecycle */
     
    render() {

        const {region, data} = this.props

        return (
            <div className="pages-shared-map-visualizer-data-popover-content">
                <Typography variant="title" gutterBottom>
                    <strong>{this.context.t(`regions.${region}`)}</strong>
                </Typography>
                {
                    data.map((dataObj, i) => {

                        const detailedData = last(dataObj.data)

                        return (
                            <div className={this.getSourceCssClass(detailedData.source)} key={i}>
                                <strong>{detailedData.value ? detailedData.value.toLocaleString('it') : '-'}{/*detailedData.value ? numeralHinstance(detailedData.value).format('0,0[.]0') : '-'*/}{detailedData.measure_unit}</strong> <small>{this.context.t(`data_types.${dataObj.data_type}`)}</small> {getSourceIcon(detailedData.source, sourceIconStyle)}
                            </div>
                        )
                    })
                }
            </div>       
        )
    }
}

DataPopoverContent.contextTypes = {
    t: PropTypes.func
}

export default DataPopoverContent


// WEBPACK FOOTER //
// ./src/components/pages/shared/map_visualizer/DataPopoverContent.js